import PropTypes from 'prop-types';
import './style.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var Mouse = function Mouse(props) {
  //nekdy na overlay se nenastaví mouseX
  var mouseX = props.mouseX,
      mouseBufferWidth = props.mouseBufferWidth,
      height = props.height,
      vertical = props.vertical;

  if (mouseX) {
    var x = vertical ? 0 : mouseX - mouseBufferWidth;
    var y = vertical ? mouseX - mouseBufferWidth : 0;
    var eHeight = vertical ? mouseBufferWidth * 2 + 1 : height;
    var width = vertical ? height : mouseBufferWidth * 2 + 1;
    return /*#__PURE__*/_jsxs("g", {
      className: "ptr-timeline-mouse",
      children: [/*#__PURE__*/_jsx("rect", {
        x: x,
        width: width,
        y: y,
        height: eHeight
      }), /*#__PURE__*/_jsx("line", {
        x1: vertical ? 0 : mouseX + 0.5,
        x2: vertical ? height : mouseX + 0.5,
        y1: vertical ? mouseX + 0.5 : 0,
        y2: vertical ? mouseX + 0.5 : height
      })]
    });
  } else {
    return null;
  }
};

Mouse.propTypes = {
  mouseX: PropTypes.number,
  mouseBufferWidth: PropTypes.number.isRequired,
  height: PropTypes.number,
  vertical: PropTypes.bool
};
Mouse.defaultProps = {
  vertical: false
};
export default Mouse;